import React from 'react'
import { reduxForm } from 'redux-form'
import validate from './validator'
import ChangePasswordFields from './fields'

const ChangePasswordForm = () => (
  <form>
    <ChangePasswordFields />
  </form>
)

const WrappedChangePasswordModal = reduxForm({
  validate,
  enableReinitialize: true,
})(ChangePasswordForm)

export default WrappedChangePasswordModal
